<template>
  <span class="font-weight-bold">{{ formattedValue }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
    },
    mediaMinima: {
      type: [Number],
      default: 7,
    },
    max: {
      type: Number,
      default: 40,
    },
    arredondamento: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      if (val > this.max) {
        this.$emit("change", parseFloat(this.max, 10));
      }
    },
  },
  created() {
    if (this.value > this.max) {
      this.$emit("change", parseFloat(this.max, 10));
    }
  },
  computed: {
    valueAsNumberOrNull() {
      return !this.valueIsEmpty ? parseFloat(this.value, 10) : null;
    },
    valueIsEmpty() {
      if (!this.value) {
        return "- - -";
      }
      // eslint-disable-next-line no-restricted-globals
      return this.value === null || this.value === undefined || isNaN(this.value);
    },
    formattedValue() {
      if (!this.value) return "- - -";
      let val = parseFloat(this.value);
      val = this.roundValue(val);
      return val <= this.max ? Math.floor(val * 10) / 10 : this.max;
    },
  },
  methods: {
    roundValue(val) {
      const decimalPart = val % 1;
      if (decimalPart >= 0.1 && decimalPart < 0.3) {
        return Math.floor(val);
      }
      if (decimalPart >= 0.3 && decimalPart < 0.8) {
        // Mudei de 0.7 para 0.8
        return Math.floor(val) + 0.5;
      }
      if (decimalPart >= 0.8) {
        return Math.ceil(val);
      }
      return val;
    },
  },
};
</script>
